import { render, staticRenderFns } from "./chart-tickets.vue?vue&type=template&id=ba1a5a38"
import script from "./chart-tickets.vue?vue&type=script&lang=ts"
export * from "./chart-tickets.vue?vue&type=script&lang=ts"
import style0 from "./chart-tickets.vue?vue&type=style&index=0&id=ba1a5a38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports